import CollectionFileElliptical from 'features/media/components/molecules/CollectionFileElliptical/CollectionFileElliptical';

export default CollectionFileElliptical;
